import React from 'react'
import IPText from '../../IPText'
import EntryTime from '../../PositionColumns/EntryTime'
import UserTag from '../../UserTag'

export const column_ip_list = mutate => {
	return [
		{
			title: '시간',
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			render: (text, record) => {
				return <EntryTime time={record?.created_at} />
			},
		},
		{
			title: '사용자',
			dataIndex: 'user_id',
			key: 'user_id',
			align: 'user_id',
			render: (text, record) => {
				return <UserTag userid={text} nickname={record?.fullname} />
			},
		},
		{
			title: 'IP',
			dataIndex: 'ip',
			key: 'ip',
			align: 'ip',
			render: (text, record) => {
				return <IPText ip={text} mutate={mutate} />
			},
		},
	]
}
